import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    firstname: yup.string().nullable().trim().label('Firstname'),
    lastname: yup.string().nullable().trim().label('Lastname'),
    email: yup.string().trim().email().required().label('Email'),
    role: yup.object().required().nullable().label('Role'),
    active: yup.boolean().required().nullable().label('Active'),
    password_api: yup.string().when('$isNewUser', {
      is: true, 
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired(),
    }).label('Password'),
  })
  .required()

const resAddUser = yupResolver(schema)

export default resAddUser
